/*
 * Copyright 2024 Collaterate. All rights reserved.
 */

var controller = {
    mode: controllerMode.FIELD_CHANGE_QUOTE,
    fieldChangeQuotePending: false,
    getFullQuotePending: false,
    enterFullQuoteMode: function () {
        this.mode = controllerMode.FULL_QUOTE;
        this.getFullQuotePending = false;
        return this.mode;
    },
    exitFullQuoteMode: function (sourceContextConfigChangeDetails) {
        if (this.mode == controllerMode.FIELD_CHANGE_QUOTE) {
            return this.mode;
        }
        this.mode = controllerMode.FIELD_CHANGE_QUOTE;
        if (this.fieldChangeQuotePending && !this.getFullQuotePending) {
            this.getFullQuotePending = true;
            setTimeout(function () {
                controller.getFullQuote(sourceContextConfigChangeDetails);
            }, 1);
        }
        return this.mode;
    },
    fullQuoteFlags: {
        isCustomDimensions: false
    },
    initialize: function () {
        var configChangeDetails = {
            context: 'init',
            category: confUtil.INIT
        };

        // init page
        var cometRequest = comet.newRequest(chandler, 'INIT', function (cometRequest) {
            var pjc = cometRequest.getObject('WORKINGLPJC');
            if (configuratorGlobals.isQuoteModePrivileged) { // if this is an admin muser, override and always allow viewing and editing of substrates and laminates.
                pjc.editSides = true;
                pjc.editDimensions = true;
                pjc.showPrintSubstrate = true;
                pjc.editPrintSubstrate = true;
                pjc.showMountSubstrate = true;
                pjc.editMountSubstrate = true;
                pjc.showFrontLaminate = true;
                pjc.editFrontLaminate = true;
                pjc.showBackLaminate = true;
                pjc.editBackLaminate = true;
            }
            configureglobals.set('clpjc', pjc);
            configureglobals.set('coffering', cometRequest.getObject('WORKINGOFFERING'));
            configureglobals.set('csides', cometRequest.getObject('SIDESDD'));
            configureglobals.set('ctips', cometRequest.getObject('TIPS'));
            controller.calcUIFullInitCallback(cometRequest, configChangeDetails);
            configureEvents.onCalcLoaded();
            configureEvents.onQuoteUpdated(configChangeDetails);
            controller.onLargeQuoteComplete(configureglobals.cquote != null);
            if (typeof shippingCalcWidgetController == 'object') {
                var cshippingcountrylist = cometRequest.getObject(shippingCalcWidgetController.countryListName).list;
                var cshippingcountry = cometRequest.getObject(shippingCalcWidgetController.countryDD);
                var cshippingzip = cometRequest.getObject(shippingCalcWidgetController.zipEF);
                var cshowEstimateShipping = cometRequest.getObject('SHOW_ESTIMATE_SHIPPING');
                shippingCalcWidgetController.initialize(chandler, cshippingcountrylist, cshippingcountry, cshippingzip, cshowEstimateShipping.value);
            }
            configureglobals.set('productionPlan', cometRequest.getObject('PRODUCTION_PLAN'));
            if (configureglobals.productionPlan) {
                window.tbg.eventHub.trigger(window.tbg.eventHub.events.PRODUCTION_PLAN_SET, [configureglobals.productionPlan.jsonObject.array]);
            } else {
                window.tbg.eventHub.trigger(window.tbg.eventHub.events.PRODUCTION_PLAN_SET, [[]]);
            }
        });
        cometRequest.addObjectId(common.offeringId);
        cometRequest.addObjectId2(configuratorGlobals.orderItemId);
        cometRequest.addParameter('reorder', getUrlParm('reorder'));
        cometRequest.addParameter('q', getUrlParm('q'));
        cometRequest.addParameter('p', getUrlParm('p'));
        setTimeout(function () {
            cometRequest.send();
        }, 1);
    },
    calcUIFullInitCallback: function (cometRequest, configChangeDetails) {
        if (cometRequest.sessionTracking) {
            growlMessages.showAll(cometRequest);
            common.setCQuoteData(cometRequest.getObject('QUOTEINPUTDATA'), cometRequest.getObject('QUOTE_INIT_WARNING_MESSAGES'));
            common.setCQuote(cometRequest.getObject('LARGEQUOTE'));
            configureglobals.set('cprintsubstratesmgr', cometRequest.getObject('PRINTSUBSTRATEDD'));
            configureglobals.set('cmountsubstratesmgr', cometRequest.getObject('MOUNTSUBSTRATEDD'));
            configureglobals.set('cfrontlaminatesmgr', cometRequest.getObject('FRONTLAMINATEDD'));
            configureglobals.set('cbacklaminatesmgr', cometRequest.getObject('BACKLAMINATEDD'));
            configureglobals.set('coperationdata', cometRequest.getObject('OPERATIONDD'));
            configureglobals.set('coperationgroupset', cometRequest.getObject('OPERATION_GROUP_SET'));
            controller.updateFullOperationSideViewModel();
            controller.generateSides();
            controller.generateDimensions();
            window.tbg.largeFormatBorderMarginsAndBleedsController.generatePieceMargin();
            window.tbg.largeFormatBorderMarginsAndBleedsController.generatePieceBleed();
            window.tbg.largeFormatBorderMarginsAndBleedsController.generateInstallerBleed();
            quantityConfigureController.generateQuantity();
            controller.generatePrintSubstrates();
            controller.generateMountSubstrates();
            controller.generateFrontLaminates();
            controller.generateBackLaminates();
            controller.generateOperations();
            controller.generateOverrideAmountDiv();
            common.generateProofs();
            common.generateTurnaroundTimes();
            var isRequoteMode = !!configureCommonGlobals.REQUOTE_MODE;
            var isFullQuoteMode = configChangeDetails && configChangeDetails.category && configChangeDetails.category === confUtil.FULL_QUOTE;
            if (!isRequoteMode && !isFullQuoteMode) {
                common.generateAdditionalFields();
            }
        } else {
            var content = '';
            content += '<div id="userMessageError">This site requires browser cookies to be enabled.<br />Please enable cookies and reload this page.</div>';
            dynamic.setDivIdContent('calculator', content);
        }
    },
    onLogin: function () {
        controller.getQuote(true, function () {
            var configChangeDetails = {
                context: 'onLogin',
                category: confUtil.LOGIN
            };
            configureEvents.onQuoteUpdated(configChangeDetails);
        });
    },
    getSideId: function (id) {
        var csides = configureglobals.csides.list;
        for (var i = 0; i < csides.length; i++) {
            var cside = csides[i];
            if (cside.id == id) {
                return cside;
            }
        }
        return null;
    },
    generateSides: function () {
        if (configureglobals.clpjc.showSides && dynamic.divIdExists('sides')) {
            var fieldName = 'SIDESDD';
            var content = '';
            var error = common.validation.hasJobQuoteFieldMessagesFor(fieldName);
            var csides = configureglobals.csides.list;
            var cselectedsides = this.getSideId(configureglobals.cquotedata.sides);
            var help = '';
            if (configureglobals.clpjc.showSidesTip) {
                help = tags.a('', 'javascript:help.tip(configureglobals.clpjc,\'sidesTip\',\'' + TBGBOLargeFormatTip.SIDES + '\')', {
                    id: 'sidesTip',
                    cssClass: 'quoteHelp',
                    tabindex: '-1',
                    title: 'More Information'
                });
            }
            if (configureglobals.clpjc.editSides == true) {
                content += help + '<label class="config">' + configureglobals.cquotedata.sidesLabel + '</label>';
                content += forms.dd(fieldName, csides, cselectedsides, {
                    showNullOption: false,
                    cssClass: 'configSelect' + (error ? ' error' : ''),
                    onchange: 'controller.setSides()'
                });
                if (error) {
                    content += common.validation.generateJobQuoteFieldMessagesFor(fieldName);
                }
            } else {
                content += help + '<label class="config">' + configureglobals.cquotedata.sidesLabel + '</label>';
                content += tags.div(cselectedsides.name, {
                    cssClass: 'noEdit'
                });
            }
            common.setOptionDiv('sides', content);
        }
    },
    setSides: function () {
        if (this.mode != controllerMode.FIELD_CHANGE_QUOTE) {
            controller.fieldChangeQuotePending = true;
            return;
        }
        var configChangeDetails = {
            context: 'setSides',
            category: confUtil.FIELD_CHANGE,
            fieldName: 'SIDESDD',
            fieldType: 'DD',
            previousValue: null,
            newValue: getDropDownSelectedValue('SIDESDD', document)
        };
        configureEvents.onCalcChanged(configChangeDetails);
        var cometRequest = comet.newRequest(chandler, 'SETSIDES', function (cometRequest) {
            common.setCQuoteData(cometRequest.getObject('QUOTEINPUTDATA'));
            common.setCQuote(cometRequest.getObject('LARGEQUOTE'));
            configureglobals.set('cprintsubstratesmgr', cometRequest.getObject('PRINTSUBSTRATEDD'));
            configureglobals.set('cmountsubstratesmgr', cometRequest.getObject('MOUNTSUBSTRATEDD'));
            configureglobals.set('cfrontlaminatesmgr', cometRequest.getObject('FRONTLAMINATEDD'));
            configureglobals.set('cbacklaminatesmgr', cometRequest.getObject('BACKLAMINATEDD'));
            growlMessages.showAll(cometRequest);
            controller.generatePrintSubstrates();
            controller.generateMountSubstrates();
            controller.generateFrontLaminates();
            controller.generateBackLaminates();
            controller.getQuote(false, function () {
                configureEvents.onQuoteUpdated(configChangeDetails);
            });
        });
        cometRequest.statusDivId = 'jobQuote';
        cometRequest.addDropDown('SIDESDD', false, document);
        setTimeout(function () {
            cometRequest.send();
        }, 1);
    },
    generateDimensions: function () {
        controller.fullQuoteFlags.isCustomDimensions = false;
        if ((configureglobals.clpjc.showDimensions || configuratorGlobals.isQuoteModePrivileged) && dynamic.divIdExists('dimensions')) {
            var widthName = 'WIDTHEF';
            var heightName = 'HEIGHTEF';
            var dimensionsName = 'PRESETDIMENSIONSDD';
            var customType = configureCommonGlobals.CUSTOM_DIMENSIONS;
            var presetType = configureCommonGlobals.PRESET_DIMENSIONS;
            var presetDimensions = configureglobals.clpjc.presetDimensions;
            var content = '';
            var cquotedata = configureglobals.cquotedata;
            var error = common.validation.hasJobQuoteFieldMessagesFor(widthName);
            var help = '';
            if (configureglobals.clpjc.showDimensionsTip) {
                help = tags.a('', 'javascript:help.tip(configureglobals.clpjc,\'dimensionsTip\',\'' + TBGBOLargeFormatTip.DIMENSIONS + '\')', {
                    id: 'dimensionsTip',
                    cssClass: 'quoteHelp',
                    tabindex: '-1',
                    title: 'More Information'
                });
            }
            if (configureglobals.clpjc.editDimensions == true) {
                content += help + '<label class="config">' + configureglobals.clpjc.dimensionsTitle + '</label>';
                var dimType = configureglobals.clpjc.dimensionsType == null ? null : configureglobals.clpjc.dimensionsType.id;
                if (dimType == customType || cquotedata.customDimensionsOption == true) {
                    controller.fullQuoteFlags.isCustomDimensions = true;
                    content += '<div class="customDimensions">';
                    content += forms.ef(widthName, cquotedata.width, {
                        size: 5,
                        cssClass: 'configField' + (error ? ' error' : ''),
                        onfocus: 'common.efFocus(\'' + widthName + '\',\'dimensions\', \'dimensionsFocus\')',
                        onblur: 'common.efBlur(\'' + widthName + '\',\'dimensions\', \'dimensionsFocus\')'
                    });
                    content += ' &#215; ';
                    content += forms.ef(heightName, cquotedata.height, {
                        size: 5,
                        cssClass: 'configField' + (error ? ' error' : ''),
                        onfocus: 'common.efFocus(\'' + heightName + '\',\'dimensions\', \'dimensionsFocus\')',
                        onblur: 'common.efBlur(\'' + heightName + '\',\'dimensions\', \'dimensionsFocus\')'
                    });
                    content += '<span id="dimensionsFocus" class="changeFocusButton"><!-- dynamic --></span>';
                    content += '</div>';
                    if (dimType == presetType && cquotedata.customDimensionsOption == true) {
                        content += '<br />';
                        content += tags.a('Use Preset Dimensions', 'javascript:controller.setCustomDimensionsOption(false)', {
                            cssClass: 'togglePreset presets'
                        });
                    }
                } else if (dimType == presetType) {
                    var ddoptions = {
                        showNullOption: false,
                        cssClass: 'configSelect' + (error ? ' error' : ''),
                        onchange: 'controller.setDimensions()',
                        propertyFunction: function (object) {
                            return object.width + ' x ' + object.height;
                        }
                    };
                    content += forms.dd(dimensionsName, presetDimensions, cquotedata.presetDimensions, ddoptions);
                    if (dimType == presetType && configureglobals.clpjc.showCustomDimensionsOption) {
                        content += tags.a('Use Custom Dimensions', 'javascript:controller.setCustomDimensionsOption(true)', {
                            cssClass: 'togglePreset customs'
                        });
                    }
                }
                if (error) {
                    content += common.validation.generateJobQuoteFieldMessagesFor(widthName);
                }
            } else {
                content += help + '<label class="config">' + configureglobals.clpjc.dimensionsTitle + '</label>';
                content += tags.div(cquotedata.width + ' x ' + cquotedata.height, {
                    cssClass: 'noEdit'
                });
            }
            common.setOptionDiv('dimensions', content);
        }
    },
    setCustomDimensionsOption: function (bool) {
        if (this.mode != controllerMode.FIELD_CHANGE_QUOTE) {
            controller.fieldChangeQuotePending = true;
            return;
        }
        var configChangeDetails = {
            context: 'setCustomDimensionsOption',
            category: confUtil.OPTION_CHANGE,
            value: bool,
            previousValue: !bool,
            newValue: bool
        };
        configureEvents.onCalcChanged(configChangeDetails);
        controller.fullQuoteFlags.isCustomDimensions = bool;
        var cometRequest = comet.newRequest(chandler, 'SETCUSTOMDIMENSIONSOPTION', function (cometRequest) {
            common.setCQuoteData(cometRequest.getObject('QUOTEINPUTDATA'));
            growlMessages.showAll(cometRequest);
            controller.display();
            configureEvents.onQuoteUpdated(configChangeDetails);
            if (!bool) {
                controller.setDimensions();
            }
        });
        cometRequest.addParameter('CUSTOM_DIMENSIONS_CB', bool);
        setTimeout(function () {
            cometRequest.send();
        }, 1);
    },
    setDimensions: function () {
        if (this.mode != controllerMode.FIELD_CHANGE_QUOTE) {
            controller.fieldChangeQuotePending = true;
            return;
        }
        var configChangeDetails = {
            context: 'setDimensions',
            category: confUtil.FIELD_CHANGE,
            fieldName: 'PRESETDIMENSIONSDD',
            fieldType: 'DD',
            previousValue: null,
            newValue: getDropDownSelectedValue('PRESETDIMENSIONSDD', document)
        };
        configureEvents.onCalcChanged(configChangeDetails);
        var cometRequest = comet.newRequest(chandler, 'SETPRESETDIMENSIONS', function (cometRequest) {
            common.setCQuoteData(cometRequest.getObject('QUOTEINPUTDATA'));
            common.setCQuote(cometRequest.getObject('LARGEQUOTE'));
            growlMessages.showAll(cometRequest);
            controller.getQuote(false, function () {
                configureEvents.onQuoteUpdated(configChangeDetails);
            });
        });
        cometRequest.statusDivId = 'jobQuote';
        cometRequest.addDropDown('PRESETDIMENSIONSDD', false, document);
        setTimeout(function () {
            cometRequest.send();
        }, 1);
    },
    generatePrintSubstrates: function () {
        if (configureglobals.clpjc.showPrintSubstrate && dynamic.divIdExists('printSubstrates')) {
            var fieldName = 'PRINTSUBSTRATEDD';
            var content = '';
            var error = common.validation.hasJobQuoteFieldMessagesFor(fieldName);
            var mgr = configureglobals.cprintsubstratesmgr;
            var cprintsubstrates = mgr.filteredElements;
            var selectedprintsubstrate = mgr.choice;
            var help = '';
            if (configureglobals.clpjc.showPrintSubstrateTip) {
                help = tags.a('', 'javascript:help.tip(configureglobals.clpjc,\'printSubstrateTip\',\'' + TBGBOLargeFormatTip.PRINTSUBSTRATES + '\')', {
                    id: 'printSubstrateTip',
                    cssClass: 'quoteHelp',
                    tabindex: '-1',
                    title: 'More Information'
                });
            }
            if (configureglobals.clpjc.editPrintSubstrate == true) {
                content += help + '<label class="config">' + mgr.label + '</label>';
                content += forms.dd(fieldName, cprintsubstrates, selectedprintsubstrate, {
                    showNullOption: !configureglobals.clpjc.requirePrintSubstrate,
                    nullOption: 'None',
                    cssClass: 'configSelect' + (error ? ' error' : ''),
                    onchange: 'controller.setPrintSubstrate()'
                });
                if (error) {
                    content += common.validation.generateJobQuoteFieldMessagesFor(fieldName);
                }
            } else {
                var cprintsubstrate = mgr.defaultElement;
                if (cprintsubstrate != null) {
                    content += help + '<label class="config">' + mgr.label + '</label>';
                    content += tags.div(cprintsubstrate.name, {
                        cssClass: 'noEdit'
                    });
                }
            }
            common.setOptionDiv('printSubstrates', content);
        }
    },
    setPrintSubstrate: function () {
        if (this.mode != controllerMode.FIELD_CHANGE_QUOTE) {
            controller.fieldChangeQuotePending = true;
            return;
        }
        var configChangeDetails = {
            context: 'setPrintSubstrate',
            category: confUtil.FIELD_CHANGE,
            fieldName: 'PRINTSUBSTRATEDD',
            fieldType: 'DD',
            previousValue: null,
            newValue: getDropDownSelectedValue('PRINTSUBSTRATEDD', document)
        };
        configureEvents.onCalcChanged(configChangeDetails);
        var cometRequest = comet.newRequest(chandler, 'SETPRINTSUBSTRATE', function (cometRequest) {
            common.setCQuoteData(cometRequest.getObject('QUOTEINPUTDATA'));
            common.setCQuote(cometRequest.getObject('LARGEQUOTE'));
            configureglobals.set('cprintsubstratesmgr', cometRequest.getObject('PRINTSUBSTRATEDD'));
            configureglobals.set('cmountsubstratesmgr', cometRequest.getObject('MOUNTSUBSTRATEDD'));
            configureglobals.set('cfrontlaminatesmgr', cometRequest.getObject('FRONTLAMINATEDD'));
            configureglobals.set('cbacklaminatesmgr', cometRequest.getObject('BACKLAMINATEDD'));
            growlMessages.showAll(cometRequest);
            controller.generatePrintSubstrates();
            controller.generateMountSubstrates();
            controller.generateFrontLaminates();
            controller.generateBackLaminates();
            controller.getQuote(false, function () {
                configureEvents.onQuoteUpdated(configChangeDetails);
            });
        });
        cometRequest.statusDivId = 'jobQuote';
        cometRequest.addDropDown('PRINTSUBSTRATEDD', false, document);
        setTimeout(function () {
            cometRequest.send();
        }, 1);
    },
    generateMountSubstrates: function () {
        if (configureglobals.clpjc.showMountSubstrate && dynamic.divIdExists('mountSubstrates')) {
            var fieldName = 'MOUNTSUBSTRATEDD';
            var content = '';
            var error = common.validation.hasJobQuoteFieldMessagesFor(fieldName);
            var mgr = configureglobals.cmountsubstratesmgr;
            var clist = mgr.filteredElements;
            var cselected = mgr.choice;
            var help = '';
            if (configureglobals.clpjc.showMountSubstrateTip) {
                help = tags.a('', 'javascript:help.tip(configureglobals.clpjc,\'mountSubstrateTip\',\'' + TBGBOLargeFormatTip.MOUNTSUBSTRATES + '\')', {
                    id: 'mountSubstrateTip',
                    cssClass: 'quoteHelp',
                    tabindex: '-1',
                    title: 'More Information'
                });
            }
            if (configureglobals.clpjc.editMountSubstrate == true) {
                content += help + '<label class="config">' + mgr.label + '</label>';
                content += forms.dd(fieldName, clist, cselected, {
                    showNullOption: !configureglobals.clpjc.requireMountSubstrate,
                    nullOption: 'None',
                    cssClass: 'configSelect' + (error ? ' error' : ''),
                    onchange: 'controller.setMountSubstrate()'
                });
                if (error) {
                    content += common.validation.generateJobQuoteFieldMessagesFor(fieldName);
                }
            } else {
                var cdefault = mgr.defaultElement;
                if (cdefault != null) {
                    content += help + '<label class="config">' + mgr.label + '</label>';
                    content += tags.div(cdefault.name, {
                        cssClass: 'noEdit'
                    });
                }
            }
            common.setOptionDiv('mountSubstrates', content);
        }
    },
    setMountSubstrate: function () {
        if (this.mode != controllerMode.FIELD_CHANGE_QUOTE) {
            controller.fieldChangeQuotePending = true;
            return;
        }
        var configChangeDetails = {
            context: 'setMountSubstrate',
            category: confUtil.FIELD_CHANGE,
            fieldName: 'MOUNTSUBSTRATEDD',
            fieldType: 'DD',
            previousValue: null,
            newValue: getDropDownSelectedValue('MOUNTSUBSTRATEDD', document)
        };
        configureEvents.onCalcChanged(configChangeDetails);
        var cometRequest = comet.newRequest(chandler, 'SETMOUNTSUBSTRATE', function (cometRequest) {
            common.setCQuoteData(cometRequest.getObject('QUOTEINPUTDATA'));
            common.setCQuote(cometRequest.getObject('LARGEQUOTE'));
            configureglobals.set('cmountsubstratesmgr', cometRequest.getObject('MOUNTSUBSTRATEDD'));
            configureglobals.set('cfrontlaminatesmgr', cometRequest.getObject('FRONTLAMINATEDD'));
            configureglobals.set('cbacklaminatesmgr', cometRequest.getObject('BACKLAMINATEDD'));
            growlMessages.showAll(cometRequest);
            controller.generateMountSubstrates();
            controller.generateFrontLaminates();
            controller.generateBackLaminates();
            controller.getQuote(false, function () {
                configureEvents.onQuoteUpdated(configChangeDetails);
            });
        });
        cometRequest.statusDivId = 'jobQuote';
        cometRequest.addDropDown('MOUNTSUBSTRATEDD', false, document);
        setTimeout(function () {
            cometRequest.send();
        }, 1);
    },
    generateFrontLaminates: function () {
        if (configureglobals.clpjc.showFrontLaminate && dynamic.divIdExists('frontLaminate')) {
            var fieldName = 'FRONTLAMINATEDD';
            var content = '';
            var error = common.validation.hasJobQuoteFieldMessagesFor(fieldName);
            var mgr = configureglobals.cfrontlaminatesmgr;
            var clist = mgr.filteredElements;
            var cselected = mgr.choice;
            var help = '';
            if (configureglobals.clpjc.showFrontLaminateTip) {
                help = tags.a('', 'javascript:help.tip(configureglobals.clpjc,\'frontLaminateTip\',\'' + TBGBOLargeFormatTip.FRONTLAMINATES + '\')', {
                    id: 'frontLaminateTip',
                    cssClass: 'quoteHelp',
                    tabindex: '-1',
                    title: 'More Information'
                });
            }
            if (configureglobals.clpjc.editFrontLaminate == true) {
                content += help + '<label class="config">' + mgr.label + '</label>';
                content += forms.dd(fieldName, clist, cselected, {
                    showNullOption: !configureglobals.clpjc.requireFrontLaminate,
                    nullOption: 'None',
                    cssClass: 'configSelect' + (error ? ' error' : ''),
                    onchange: 'controller.setFrontLaminate()'
                });
                if (error) {
                    content += common.validation.generateJobQuoteFieldMessagesFor(fieldName);
                }
            } else {
                var cdefault = mgr.defaultElement;
                if (cdefault != null) {
                    content += help + '<label class="config">' + mgr.label + '</label>';
                    content += tags.div(cdefault.name, {
                        cssClass: 'noEdit'
                    });
                }
            }
            common.setOptionDiv('frontLaminate', content);
        }
    },
    setFrontLaminate: function () {
        if (this.mode != controllerMode.FIELD_CHANGE_QUOTE) {
            controller.fieldChangeQuotePending = true;
            return;
        }
        var configChangeDetails = {
            context: 'setFrontLaminate',
            category: confUtil.FIELD_CHANGE,
            fieldName: 'FRONTLAMINATEDD',
            fieldType: 'DD',
            previousValue: null,
            newValue: getDropDownSelectedValue('FRONTLAMINATEDD', document)
        };
        configureEvents.onCalcChanged(configChangeDetails);
        var cometRequest = comet.newRequest(chandler, 'SETFRONTLAMINATE', function (cometRequest) {
            common.setCQuoteData(cometRequest.getObject('QUOTEINPUTDATA'));
            common.setCQuote(cometRequest.getObject('LARGEQUOTE'));
            configureglobals.set('cfrontlaminatesmgr', cometRequest.getObject('FRONTLAMINATEDD'));
            configureglobals.set('cbacklaminatesmgr', cometRequest.getObject('BACKLAMINATEDD'));
            growlMessages.showAll(cometRequest);
            controller.generateFrontLaminates();
            controller.generateBackLaminates();
            controller.getQuote(false, function () {
                configureEvents.onQuoteUpdated(configChangeDetails);
            });
        });
        cometRequest.statusDivId = 'jobQuote';
        cometRequest.addDropDown('FRONTLAMINATEDD', false, document);
        setTimeout(function () {
            cometRequest.send();
        }, 1);
    },
    generateBackLaminates: function () {
        if (configureglobals.clpjc.showBackLaminate && dynamic.divIdExists('backLaminate')) {
            var fieldName = 'BACKLAMINATEDD';
            var content = '';
            var error = common.validation.hasJobQuoteFieldMessagesFor(fieldName);
            var mgr = configureglobals.cbacklaminatesmgr;
            var clist = mgr.filteredElements;
            var cselected = mgr.choice;
            var help = '';
            if (configureglobals.clpjc.showBackLaminateTip) {
                help = tags.a('', 'javascript:help.tip(configureglobals.clpjc,\'backLaminateTip\',\'' + TBGBOLargeFormatTip.BACKLAMINATES + '\')', {
                    id: 'backLaminateTip',
                    cssClass: 'quoteHelp',
                    tabindex: '-1',
                    title: 'More Information'
                });
            }
            if (configureglobals.clpjc.editBackLaminate == true) {
                content += help + '<label class="config">' + mgr.label + '</label>';
                var allowNone = !configureglobals.clpjc.requireBackLaminate && mgr.allowNone;
                content += forms.dd(fieldName, clist, cselected, {
                    showNullOption: allowNone,
                    nullOption: 'None',
                    cssClass: 'configSelect' + (error ? ' error' : ''),
                    onchange: 'controller.setBackLaminate()'
                });
                if (error) {
                    content += common.validation.generateJobQuoteFieldMessagesFor(fieldName);
                }
            } else {
                var cdefault = mgr.defaultElement;
                if (cdefault != null) {
                    content += help + '<label class="config">' + mgr.label + '</label>';
                    content += tags.div(cdefault.name, {
                        cssClass: 'noEdit'
                    });
                }
            }
            common.setOptionDiv('backLaminate', content);
        }
    },
    setBackLaminate: function () {
        if (this.mode != controllerMode.FIELD_CHANGE_QUOTE) {
            controller.fieldChangeQuotePending = true;
            return;
        }
        var configChangeDetails = {
            context: 'setBackLaminate',
            category: confUtil.FIELD_CHANGE,
            fieldName: 'BACKLAMINATEDD',
            fieldType: 'DD',
            previousValue: null,
            newValue: getDropDownSelectedValue('BACKLAMINATEDD', document)
        };
        configureEvents.onCalcChanged(configChangeDetails);
        var cometRequest = comet.newRequest(chandler, 'SETBACKLAMINATE', function (cometRequest) {
            common.setCQuoteData(cometRequest.getObject('QUOTEINPUTDATA'));
            common.setCQuote(cometRequest.getObject('LARGEQUOTE'));
            configureglobals.set('cbacklaminatesmgr', cometRequest.getObject('BACKLAMINATEDD'));
            growlMessages.showAll(cometRequest);
            controller.generateBackLaminates();
            controller.getQuote(false, function () {
                configureEvents.onQuoteUpdated(configChangeDetails);
            });
        });
        cometRequest.statusDivId = 'jobQuote';
        cometRequest.addDropDown('BACKLAMINATEDD', false, document);
        setTimeout(function () {
            cometRequest.send();
        }, 1);
    },
    generateOperations: function () {
        var content = '';
        var coperationdata = configureglobals.coperationdata.list;
        var operationGroupSet = configureglobals.coperationgroupset;
        var operationGroups = operationGroupSet ? operationGroupSet.operationGroups : [];
        var groupData = prepareOperationGroupData(operationGroups, coperationdata);

        if (groupData.length && coperationdata) {
            for (var i = 0, className = ''; i < groupData.length; i++) {
                className = generateClassName(groupData[i].label);

                content += '<div class="operationsGroupWrapper operationsGroupWrapper--' + className + '">';
                content += '<h3>' + groupData[i].label + '</h3>';
                content += '<fieldset class="operationsGroup">';
                for (var j = 0; j < groupData[i].operations.length; j++) {
                    content += prepareOperationMarkup(groupData[i].operations[j], groupData[i].operations[j].originalIndex);
                }
                content += '</fieldset>';
                content += '</div>';
            }
        } else if (coperationdata) {
            for (var i = 0; i < coperationdata.length; i++) {
                content += prepareOperationMarkup(coperationdata[i], i);
            }
        }

        if (content.length && !operationGroupSet) {
            content = '<h3>Finishing</h3><fieldset class="operationsGroup">' + content + '</fieldset>';
        } else if (!content.length) {
            dynamic.setClass('operationsDiv', 'optionWrapperEmpty');
        }

        dynamic.setDivIdContent('operationsDiv', content);
        this.refreshOperationFieldErrorMessages();

        return;

        function generateClassName (label) {
            return label
                .trim()
                .toLowerCase()
                .replace(/\s\s*/g, '-');
        }

        function prepareOperationMarkup (operationData, i) {
            var content = '';
            var ddName = 'OPERATIONDD';
            var anoperationdata = coperationdata[i];
            var cchoices = anoperationdata.choices;
            var cchoice = anoperationdata.choice;
            var clpjcoperation = anoperationdata.lpjcOperation;
            var coperation = clpjcoperation.operation;
            var help = '';
            var fieldName,
                dderror,
                costType,
                efName,
                eferror,
                focusSurround,
                focusButton,
                aName;
            var internalOnly = false;
            var getChoiceDisplayName = function (cchoice) {
                var displayName = cchoice.name;
                if (cchoice.adminOnly) {
                    displayName += ' (Internal Only)';
                }
                return displayName;
            };

            // if user is an Supplier Admin, override and always show.
            if (configuratorGlobals.isQuoteModePrivileged) {
                // when showing an operation that would normally be hidden but for privileged mode, show "internal only" label.
                if (!clpjcoperation.show) {
                    internalOnly = true;
                }
                clpjcoperation.show = true;
                clpjcoperation.editable = true;
            }

            // Hide internal only operations if there are 0 to 1 choices
            if (internalOnly && (!cchoices || cchoices.length < 2)) {
                clpjcoperation.show = false;
            }

            if (clpjcoperation.show == true) {
                if (clpjcoperation.showTip) {
                    help = tags.a('', 'javascript:help.lfOpTip(' + i + ')', {
                        id: 'opTip' + i,
                        cssClass: 'quoteHelp',
                        tabindex: '-1',
                        title: 'More Information'
                    });
                }

                content += '<div class="optionWrapperOn' + (coperation.costingOnly ? ' costingOnly' : '') + '" id="operation' + coperation.id + '">';

                if (internalOnly) {
                    content += help + '<label class="config internal-only">' + strWeb(coperation.heading) + ' (Internal Only)</label>';
                } else {
                    content += help + '<label class="config">' + strWeb(coperation.heading) + '</label>';
                }

                if (clpjcoperation.editable) {
                    fieldName = ddName + i;
                    dderror = common.validation.hasJobQuoteFieldMessagesFor(fieldName);

                    content += forms.dd(fieldName, cchoices, cchoice, {
                        showNullOption: clpjcoperation.showNoneItem,
                        nullOption: 'None',
                        cssClass: dderror ? 'opSelectError' : 'opSelect',
                        onchange: 'controller.setOperation(' + i + ')',
                        id: 'operation' + coperation.id,
                        propertyFunction: getChoiceDisplayName
                    });

                    content += '<div id="' + fieldName + 'FieldErrorMessage"><!-- dynamic --></div>';
                } else {
                    if (cchoice) {
                        content += tags.div(strWeb(cchoice.name), {
                            cssClass: 'noEdit'
                        });
                    }
                }

                // item question
                if (cchoice) {
                    costType = parseInt(cchoice.costType.id, 10);

                    if (costType === largeFormatGlobals.OPITEM_QUANTITY && cchoice.editableValues) {
                        efName = 'OPERATIONQUANTITYEF' + i;
                        eferror = common.validation.hasJobQuoteFieldMessagesFor(efName);
                        focusSurround = efName + 'Surround';
                        focusButton = efName + 'Focus';

                        content += '<div class="op lf">';
                        content += '<div id="' + focusSurround + '" >';
                        content += '<label class="opQuestion">How many per quantity?</label>';
                        content += forms.ef(efName, anoperationdata.quantity, {
                            size: 10,
                            cssClass: 'configField' + (eferror ? ' error' : ''),
                            onfocus: 'common.efFocus(\'' + efName + '\',\'' + focusSurround + '\', \'' + focusButton + '\')',
                            onblur: 'common.efBlur(\'' + efName + '\',\'' + focusSurround + '\', \'' + focusButton + '\')',
                            id: 'operationQuantity' + coperation.id
                        });
                        content += '<span id="' + focusButton + '" class="changeFocusButton"><!-- dynamic --></span>';
                        content += '<div id="' + efName + 'FieldErrorMessage"><!-- dynamic --></div>';
                        content += '</div>';
                        content += '</div>';
                    } else if (costType === largeFormatGlobals.OPITEM_LINEAR_FEET && cchoice.editableValues) {
                        aName = ddName + '_CB';
                        content += '<div class="op lf">';
                        content += '<label class="opQuestion">Select applicable edges</label>';
                        content += '<div class="configCheckbox"><label class="configCheckbox-label"><input id="operationLinearFeetTop' + coperation.id + '" onchange="controller.setOperationTop(' + i + ')" type="checkbox" name="' + aName + '_TOP_' + i + '" class="configCheckbox-input" ' + (controller.operationTops[i] ? 'checked' : '') + ' />Top</label></div>';
                        content += '<div class="configCheckbox"><label class="configCheckbox-label"><input id="operationLinearFeetBottom' + coperation.id + '" onchange="controller.setOperationBottom(' + i + ')" type="checkbox" name="' + aName + '_BOTTOM_' + i + '" class="configCheckbox-input" ' + (controller.operationBottoms[i] ? 'checked' : '') + ' />Bottom</label></div>';
                        content += '<div class="configCheckbox"><label class="configCheckbox-label"><input id="operationLinearFeetLeft' + coperation.id + '" onchange="controller.setOperationLeft(' + i + ')" type="checkbox" name="' + aName + '_LEFT_' + i + '" class="configCheckbox-input" ' + (controller.operationLefts[i] ? 'checked' : '') + ' />Left</label></div>';
                        content += '<div class="configCheckbox"><label class="configCheckbox-label"><input id="operationLinearFeetRight' + coperation.id + '" onchange="controller.setOperationRight(' + i + ')" type="checkbox" name="' + aName + '_RIGHT_' + i + '" class="configCheckbox-input" ' + (controller.operationRights[i] ? 'checked' : '') + ' />Right</label></div>';
                        content += '</div>';
                    } else if ((costType === largeFormatGlobals.OPITEM_COSTED_ADD_ON
                            || costType === largeFormatGlobals.OPITEM_DIRECT_ADD_ON
                            || costType === largeFormatGlobals.OPITEM_COSTED_ADD_ON_PER_PIECE)
                        && cchoice.editableValues) {
                        efName = 'OPERATION_ADD_ON_VALUE_EF' + i;
                        eferror = common.validation.hasJobQuoteFieldMessagesFor(efName);
                        focusSurround = efName + 'Surround';
                        focusButton = efName + 'Focus';

                        content += '<div class="op lf">';
                        content += '<div id="' + focusSurround + '" >';
                        content += '<label class="opQuestion">How much per job?</label>';
                        content += forms.ef(efName, anoperationdata.addOnValue, {
                            size: 10,
                            cssClass: 'configField' + (eferror ? ' error' : ''),
                            onfocus: 'common.efFocus(\'' + efName + '\',\'' + focusSurround + '\', \'' + focusButton + '\')',
                            onblur: 'common.efBlur(\'' + efName + '\',\'' + focusSurround + '\', \'' + focusButton + '\')',
                            id: 'operationAddOnValue' + coperation.id
                        });
                        content += '<span id="' + focusButton + '" class="changeFocusButton"><!-- dynamic --></span>';
                        content += '<div id="' + efName + 'FieldErrorMessage"><!-- dynamic --></div>';
                        content += '</div>';
                        content += '</div>';
                    } else if (costType === largeFormatGlobals.OPITEM_QUANTITY_DIVISOR && cchoice.editableValues) {
                        efName = 'OPERATION_QUANTITY_DIVISOR_EF' + i;
                        eferror = common.validation.hasJobQuoteFieldMessagesFor(efName);
                        focusSurround = efName + 'Surround';
                        focusButton = efName + 'Focus';

                        content += '<div class="op lf">';
                        content += '<div id="' + focusSurround + '" >';
                        content += '<label class="opQuestion">What is the denominator?</label>';
                        content += forms.ef(efName, anoperationdata.quantityDivisor, {
                            size: 10,
                            cssClass: 'configField' + (eferror ? ' error' : ''),
                            onfocus: 'common.efFocus(\'' + efName + '\',\'' + focusSurround + '\', \'' + focusButton + '\')',
                            onblur: 'common.efBlur(\'' + efName + '\',\'' + focusSurround + '\', \'' + focusButton + '\')',
                            id: 'operationQuantityDivisor' + coperation.id
                        });
                        content += '<span id="' + focusButton + '" class="changeFocusButton"><!-- dynamic --></span>';
                        content += '<div id="' + efName + 'FieldErrorMessage"><!-- dynamic --></div>';
                        content += '</div>';
                        content += '</div>';
                    }
                }
                content += '</div><!-- optionWrapper -->';
            }

            return content;
        }

        function prepareOperationGroupData (groups, opData) {
            var operationGroupData = [];
            var operations;

            if (!groups || !groups.length || !opData) {
                return operationGroupData;
            }

            // We are going to alter the array, make a copy of it
            // to leave original intact for other users
            operationData = opData.slice();

            // Save original index for use in things like tips etc...
            for (var i = 0; i < operationData.length; i++) {
                operationData[i].originalIndex = i;
            }

            // Loop through groups and match any listed operations
            // to operationData items returned for this product
            for (var j = 0, entry, tempOperations; j < groups.length; j++) {
                entry = {
                    label: groups[j].label,
                    operations: []
                };

                tempOperations = [];

                for (var k = 0, ii; k < groups[j].operations.length; k++) {
                    ii = 0;
                    while (ii < operationData.length) {
                        if (groups[j].operations[k].id === operationData[ii].lpjcOperation.operation.id) {
                            if (operationData[ii].lpjcOperation.show) {
                                tempOperations.push(operationData[ii]);
                            }
                            operationData.splice(ii, 1);
                            continue;
                        }
                        ii++;
                    }
                }

                if (tempOperations.length) {
                    entry.operations = tempOperations;
                    operationGroupData.push(entry);
                }
            }

            // If there are any operationData items not sorted into a group yet,
            // add them to a catch all group
            if (operationData.length) {
                operationGroupData.push({
                    label: 'Other',
                    operations: operationData
                });
            }

            return operationGroupData;
        }
    },
    refreshOperationFieldErrorMessages: function () {
        var coperationdata = configureglobals.coperationdata.list;
        if (coperationdata == null) {
            return;
        }
        for (var i = 0; i < coperationdata.length; i++) {
            var anoperationdata = coperationdata[i];
            var clpjcoperation = anoperationdata.lpjcOperation;
            var coperation = clpjcoperation.operation;
            var cchoices = anoperationdata.choices;
            var cchoice = anoperationdata.choice;
            var content = '';

            // dd
            var fieldName = 'OPERATIONDD' + i;
            var dderror = common.validation.hasJobQuoteFieldMessagesFor(fieldName);
            if (dderror) {
                content += common.validation.generateJobQuoteFieldMessagesFor(fieldName);
            }
            dynamic.setDivIdContent(fieldName + 'FieldErrorMessage', content);
            content = '';

            // item question
            if (cchoice != null) {
                var costType = parseInt(cchoice.costType.id, 10);
                var efName = null;
                var eferror = null;
                if (costType === largeFormatGlobals.OPITEM_QUANTITY && cchoice.editableValues) {
                    efName = 'OPERATIONQUANTITYEF' + i;
                } else if ((costType === largeFormatGlobals.OPITEM_COSTED_ADD_ON
                        || costType === largeFormatGlobals.OPITEM_DIRECT_ADD_ON
                        || costType === largeFormatGlobals.OPITEM_COSTED_ADD_ON_PER_PIECE)
                    && cchoice.editableValues) {
                    efName = 'OPERATION_ADD_ON_VALUE_EF' + i;
                } else if (costType === largeFormatGlobals.OPITEM_QUANTITY_DIVISOR && cchoice.editableValues) {
                    efName = 'OPERATION_QUANTITY_DIVISOR_EF' + i;
                }
                eferror = common.validation.hasJobQuoteFieldMessagesFor(efName);
                if (eferror) {
                    content += common.validation.generateJobQuoteFieldMessagesFor(efName);
                }
            }
            dynamic.setDivIdContent(efName + 'FieldErrorMessage', content);
        }
    },
    operationTops: null,
    operationBottoms: null,
    operationLefts: null,
    operationRights: null,
    updateFullOperationSideViewModel: function () {
        controller.operationTops = [];
        controller.operationBottoms = [];
        controller.operationLefts = [];
        controller.operationRights = [];
        var operationDataList = configureglobals.coperationdata.list;
        operationDataList != null && operationDataList.forEach(function (operationData, index) {
            controller.updateOperationSideViewModel(index, operationData);
        });
    },
    updateOperationSideViewModel: function (operationDataIndex, operationData) {
        if (operationData != null) {
            this.operationTops[operationDataIndex] = operationData.topSide !== undefined ? operationData.topSide : operationData.defaultTopSide;
            this.operationBottoms[operationDataIndex] = operationData.bottomSide !== undefined ? operationData.bottomSide : operationData.defaultBottomSide;
            this.operationLefts[operationDataIndex] = operationData.leftSide !== undefined ? operationData.leftSide : operationData.defaultLeftSide;
            this.operationRights[operationDataIndex] = operationData.rightSide !== undefined ? operationData.rightSide : operationData.defaultRightSide;
        }
    },
    getOperationDataChoicesChoiceWithId: function (operationDataIndex, findChoiceId) {
        var foundChoice = null;
        var operationDataList = configureglobals.coperationdata.list;
        var choiceList = operationDataList && operationDataList[operationDataIndex] && operationDataList[operationDataIndex].choices && operationDataList[operationDataIndex].choices;
        if (choiceList) {
            choiceList.forEach(function (choice) {
                if (choice.id == findChoiceId) {
                    foundChoice = choice;
                }
            });
        }
        return foundChoice;
    },
    setOperationTop: function (index) {
        this.operationTops[index] = !this.operationTops[index];
        var configChangeDetails = {
            context: 'setOperationTop',
            category: confUtil.INDEXED_FIELD_CHANGE,
            fieldNamePrefix: 'OPERATIONDD',
            fieldType: 'DD',
            fieldIndex: index,
            previousValue: !this.operationTops[index],
            newValue: this.operationTops[index]
        };
        this.setOperationSideOrSelection(configChangeDetails);
    },
    setOperationBottom: function (index) {
        this.operationBottoms[index] = !this.operationBottoms[index];
        var configChangeDetails = {
            context: 'setOperationBottom',
            category: confUtil.INDEXED_FIELD_CHANGE,
            fieldNamePrefix: 'OPERATIONDD',
            fieldType: 'DD',
            fieldIndex: index,
            previousValue: !this.operationBottoms[index],
            newValue: this.operationBottoms[index]
        };
        this.setOperationSideOrSelection(configChangeDetails);
    },
    setOperationLeft: function (index) {
        this.operationLefts[index] = !this.operationLefts[index];
        var configChangeDetails = {
            context: 'setOperationLeft',
            category: confUtil.INDEXED_FIELD_CHANGE,
            fieldNamePrefix: 'OPERATIONDD',
            fieldType: 'DD',
            fieldIndex: index,
            previousValue: !this.operationLefts[index],
            newValue: this.operationLefts[index]
        };
        this.setOperationSideOrSelection(configChangeDetails);
    },
    setOperationRight: function (index) {
        this.operationRights[index] = !this.operationRights[index];
        var configChangeDetails = {
            context: 'setOperationRight',
            category: confUtil.INDEXED_FIELD_CHANGE,
            fieldNamePrefix: 'OPERATIONDD',
            fieldType: 'DD',
            fieldIndex: index,
            previousValue: !this.operationRights[index],
            newValue: this.operationRights[index]
        };
        this.setOperationSideOrSelection(configChangeDetails);
    },
    setOperationSideOrSelection: function (configChangeDetails) {
        if (this.mode != controllerMode.FIELD_CHANGE_QUOTE) {
            controller.fieldChangeQuotePending = true;
            return;
        }
        var index = configChangeDetails.fieldIndex;
        var anoperationdata = configureglobals.coperationdata.list ? configureglobals.coperationdata.list[index] : null;
        if (anoperationdata == null) {
            return;
        }
        configureEvents.onCalcChanged(configChangeDetails);
        var cometRequest = comet.newRequest(chandler, 'SETOPERATION', function (cometRequest) {
            common.setCQuoteData(cometRequest.getObject('QUOTEINPUTDATA'));
            common.setCQuote(cometRequest.getObject('LARGEQUOTE'));
            configureglobals.set('coperationdata', cometRequest.getObject('OPERATIONDD'));
            controller.updateFullOperationSideViewModel();
            growlMessages.showAll(cometRequest);
            controller.generateOperations();
            controller.getQuote(false, function () {
                configureEvents.onQuoteUpdated(configChangeDetails);
            });
        });
        cometRequest.statusDivId = 'jobQuote';
        cometRequest.addObject('OPERATIONDD', {
            selections: [this.buildOperationSelectionResource(index, anoperationdata)]
        });
        setTimeout(function () {
            cometRequest.send();
        }, 1);
    },
    setOperation: function (index) {
        var configChangeDetails = {
            context: 'setOperation',
            category: confUtil.INDEXED_FIELD_CHANGE,
            fieldIndex: index,
            fieldNamePrefix: 'OPERATIONDD',
            fieldType: 'DD',
            previousValue: null,
            newValue: getDropDownSelectedValue('OPERATIONDD' + index, document)
        };
        var newChoice = controller.getOperationDataChoicesChoiceWithId(index, configChangeDetails.newValue);
        this.updateOperationSideViewModel(index, newChoice);
        this.setOperationSideOrSelection(configChangeDetails);
    },
    parentController: null,
    onLargeQuoteComplete: function (success) {
        if (this.parentController != null) {
            this.parentController.largeQuoteComplete(success);
        }
        if (typeof shippingCalcWidgetController == 'object') {
            shippingCalcWidgetController.onQuoteChange();
        }
    },
    generateOverrideAmountDiv: function () {
        if (dynamic.divIdExists('overrideAmountDiv') && configuratorGlobals.isQuoteModePrivileged) {
            var fieldName = 'TOTAL_PRICE_OVERRIDE_AMOUNT_EF';
            var content = '';
            var cquotedata = configureglobals.cquotedata;
            var error = common.validation.hasJobQuoteFieldMessagesFor(fieldName);

            content += '<h3>Price Adjustment</h3>';
            content += forms.ef(fieldName, cquotedata.totalPriceOverrideAmount, {
                size: 15,
                style: 'width:auto',
                cssClass: 'configField' + (error ? ' error' : ''),
                onfocus: 'common.efFocus(\'' + fieldName + '\',\'overrideAmountDiv\', \'overrideAmountFocus\')',
                onblur: 'common.efBlur(\'' + fieldName + '\',\'overrideAmountDiv\', \'overrideAmountFocus\')'
            });
            content += '<span id="overrideAmountFocus" class="changeFocusButton"><!-- dynamic --></span>';
            if (error) {
                content += common.validation.generateJobQuoteFieldMessagesFor(fieldName);
            }
            common.setOptionDiv('overrideAmountDiv', content);
        }
    },
    display: function () {
        controller.generateSides();
        controller.generateDimensions();
        window.tbg.largeFormatBorderMarginsAndBleedsController.generatePieceMargin();
        window.tbg.largeFormatBorderMarginsAndBleedsController.generatePieceBleed();
        window.tbg.largeFormatBorderMarginsAndBleedsController.generateInstallerBleed();
        quantityConfigureController.generateQuantity();
        controller.generatePrintSubstrates();
        controller.generateMountSubstrates();
        controller.generateFrontLaminates();
        controller.generateBackLaminates();

        // only refresh operation messages. not controller.generateOperations() since coperationdata is not sent back for GET_FIELD_CHANGE_QUOTE_ACTIONs
        controller.refreshOperationFieldErrorMessages();
        controller.generateOverrideAmountDiv();
    },
    setOutsourced: function (value) {
        var cometRequest = comet.newRequest(chandler, 'SETOUTSOURCED', function (cometRequest) {
            common.setCQuoteData(cometRequest.getObject('QUOTEINPUTDATA'));
            common.setCQuote(cometRequest.getObject('LARGEQUOTE'));
            growlMessages.showAll(cometRequest);
        });
        cometRequest.statusDivId = 'outsourceDiv';
        cometRequest.addParameter('OUTSOURCED_CB', value);
        cometRequest.send();
    },
    getQuote: function (isLogin, onQuoteUpdatedFunction) {
        if (this.mode != controllerMode.FIELD_CHANGE_QUOTE) {
            controller.fieldChangeQuotePending = true;
            return;
        }
        var cometRequest = comet.newRequest(chandler, 'GET_FIELD_CHANGE_QUOTE_ACTION', function (cometRequest) {
            common.setCQuoteData(cometRequest.getObject('QUOTEINPUTDATA'));
            common.setCQuote(cometRequest.getObject('LARGEQUOTE'));
            configureglobals.set('productionPlan', cometRequest.getObject('PRODUCTION_PLAN'));
            if (configureglobals.productionPlan) {
                window.tbg.eventHub.trigger(window.tbg.eventHub.events.PRODUCTION_PLAN_SET, [configureglobals.productionPlan.jsonObject.array]);
            } else {
                window.tbg.eventHub.trigger(window.tbg.eventHub.events.PRODUCTION_PLAN_SET, [[]]);
            }
            growlMessages.showAll(cometRequest);
            controller.display();
            controller.fieldChangeQuotePending = false;
            if (isLogin && typeof shippingCalcWidgetController == 'object') {
                var cshippingcountry = cometRequest.getObject(shippingCalcWidgetController.countryDD);
                var cshippingzip = cometRequest.getObject(shippingCalcWidgetController.zipEF);
                shippingCalcWidgetController.onLogin(cshippingcountry, cshippingzip);
            }
            controller.onLargeQuoteComplete(configureglobals.cquote != null);
            if (common.ef != null) {
                focusOn(common.ef, document);
                selectAll(common.ef, document);
            }
            if (typeof onQuoteUpdatedFunction == 'function') {
                setTimeout(function () {
                    onQuoteUpdatedFunction();
                }, 1);
            }
        });
        this.decorateCometRequestForGetQuote(cometRequest, isLogin);
        dynamic.setDivIdContent('jobQuote', '--');
        setTimeout(function () {
            cometRequest.send();
        }, 1);
    },
    decorateCometRequestForGetQuote: function (cometRequest, isLogin) {
        cometRequest.statusDivId = 'jobQuote';
        cometRequest.addParameter('reorder', getUrlParm('reorder'));
        cometRequest.addParameter('p', getUrlParm('p'));
        if (isLogin) {
            cometRequest.addParameter('ONLOGIN', 'true');
        }
        cometRequest.addFormField('WIDTHEF', false, document);
        cometRequest.addFormField('HEIGHTEF', false, document);
        cometRequest.addFormField('QUANTITYEF', false, document);
        cometRequest.addFormField('QUANTITY_PER_VERSION_EF', false, document);
        cometRequest.addFormField('VERSION_COUNT_EF', false, document);
        cometRequest.addFormField('TOTAL_PRICE_OVERRIDE_AMOUNT_EF', false, document);

        window.tbg.largeFormatBorderMarginsAndBleedsController.decorateCometRequestForGetQuote(cometRequest);

        var coperationdata = configureglobals.coperationdata.list;
        if (coperationdata != null) {
            for (var i = 0; i < coperationdata.length; i++) {
                var anoperationdata = coperationdata[i];
                var clpjcoperation = anoperationdata.lpjcOperation;
                var cchoice = anoperationdata.choice;
                if (clpjcoperation.editable && cchoice != null) {
                    var costType = parseInt(cchoice.costType.id, 10);
                    if (costType === largeFormatGlobals.OPITEM_QUANTITY) {
                        cometRequest.addFormField('OPERATIONQUANTITYEF' + i, false, document);
                    } else if (costType === largeFormatGlobals.OPITEM_COSTED_ADD_ON
                        || costType === largeFormatGlobals.OPITEM_DIRECT_ADD_ON
                        || costType === largeFormatGlobals.OPITEM_COSTED_ADD_ON_PER_PIECE) {
                        cometRequest.addFormField('OPERATION_ADD_ON_VALUE_EF' + i, false, document);
                    } else if (costType === largeFormatGlobals.OPITEM_QUANTITY_DIVISOR && cchoice.editableValues) {
                        cometRequest.addFormField('OPERATION_QUANTITY_DIVISOR_EF' + i, false, document);
                    }
                }
            }
        }
    },
    getFullQuote: function (sourceContextConfigChangeDetails) {
        var configChangeDetails = {
            category: confUtil.FULL_QUOTE,
            contextLevel: sourceContextConfigChangeDetails == null || !sourceContextConfigChangeDetails.contextLevel ? 1 : sourceContextConfigChangeDetails.contextLevel + 1,
            context: sourceContextConfigChangeDetails
        };

        // submit all fields at once and also getQuote
        var cometRequest = comet.newRequest(chandler, 'GET_FULL_QUOTE_ACTION', function (cometRequest) {
            controller.calcUIFullInitCallback(cometRequest, configChangeDetails);
            configureEvents.onQuoteUpdated(configChangeDetails);
            controller.fieldChangeQuotePending = false;
        });

        // do all decorators here, then decorateCometRequestForGetQuote
        {
            // Each of these "cometRequest.addDropDown" calls are wrapped in an "if" that matches the conditions required to write the corresponding "DD" field to the DOM.
            // This is so that the full-quote mode request does not send a field to the backend that does not exist here.  TBG-3177
            if (configureglobals.clpjc.showSides && dynamic.divIdExists('sides') && configureglobals.clpjc.editSides == true) {
                cometRequest.addDropDown('SIDESDD', false, document);
            }
            var dimType = configureglobals.clpjc.dimensionsType == null ? null : configureglobals.clpjc.dimensionsType.id;
            if ((configureglobals.clpjc.showDimensions || configuratorGlobals.isQuoteModePrivileged) && dynamic.divIdExists('dimensions') && configureglobals.clpjc.editDimensions == true && !configureglobals.cquotedata.customDimensionsOption && dimType == configureCommonGlobals.PRESET_DIMENSIONS) {
                cometRequest.addDropDown('PRESETDIMENSIONSDD', false, document);
            }
            cometRequest.addParameter('CUSTOM_DIMENSIONS_CB', controller.fullQuoteFlags.isCustomDimensions);
            window.tbg.largeFormatBorderMarginsAndBleedsController.decorateCometRequestForGetQuote(cometRequest);
            if (configureglobals.clpjc.showPrintSubstrate && dynamic.divIdExists('printSubstrates') && configureglobals.clpjc.editPrintSubstrate == true) {
                cometRequest.addDropDown('PRINTSUBSTRATEDD', false, document);
            }
            if (configureglobals.clpjc.showMountSubstrate && dynamic.divIdExists('mountSubstrates') && configureglobals.clpjc.editMountSubstrate == true) {
                cometRequest.addDropDown('MOUNTSUBSTRATEDD', false, document);
            }
            if (configureglobals.clpjc.showFrontLaminate && dynamic.divIdExists('frontLaminate') && configureglobals.clpjc.editFrontLaminate == true) {
                cometRequest.addDropDown('FRONTLAMINATEDD', false, document);
            }
            if (configureglobals.clpjc.showBackLaminate && dynamic.divIdExists('backLaminate') && configureglobals.clpjc.editBackLaminate == true) {
                cometRequest.addDropDown('BACKLAMINATEDD', false, document);
            }
            var coffering = configureglobals.coffering;
            if (coffering.getPublishedShowProof() && coffering.getPublishedEditProof()) {
                cometRequest.addDropDown('PROOFDD', false, document);
            }
            if (coffering.getPublishedShowTurnaroundTime() && coffering.getPublishedEditTurnaroundTime()) {
                cometRequest.addDropDown('TURNAROUNDTIMEDD', false, document);
            }

            var operationSelections = new Array();
            $(configureglobals.coperationdata.list).each(function (index, node) {
                if (node.lpjcOperation.editable) {
                    operationSelections.push(controller.buildOperationSelectionResource(index, node));
                }
            });
            cometRequest.addObject('OPERATIONDD', {
                selections: operationSelections
            });
        }
        controller.decorateCometRequestForGetQuote(cometRequest, false);

        dynamic.setDivIdContent('jobQuote', '--');
        cometRequest.send();
    },
    buildOperationSelectionResource: function (index, operationDataEntity) {
        return {
            index: index,
            lpjcOperationId: operationDataEntity.lpjcOperation.id,
            operationId: operationDataEntity.lpjcOperation.operation.id,
            selectedItemId: parseInt(getDropDownSelectedValue('OPERATIONDD' + index, document), 10),
            topSide: controller.operationTops[index],
            bottomSide: controller.operationBottoms[index],
            leftSide: controller.operationLefts[index],
            rightSide: controller.operationRights[index]
        };
    }
};

$(function () {
    controller.initialize();
});
